import React, { useState } from "react";
import { roleAccess } from "helpers/RolesPermission";
import HumanBodyModal from "components/Modals/HumanBody/HumanBodyModal";
import { USER_ROLE } from "Constants/constant";
import { FiArrowUpRight } from "react-icons/fi";
import { parseBooleanVal } from "Utils/utils";
import CustomButton from "../Button/CustomButton";

const SupportPlanItem = (props) => {
  const { item, viewInitialAssesmentForm, form_uuid } = props;

  const [openBodyModal, setOpenBodyModal] = useState(false);
  const [selectedBody, setSelectedBody] = useState("");

  const getValue = () => {
    const { value, type } = item;
    if (value === null || value === "") {
      return (
        <>
          {roleAccess([USER_ROLE.Sp_Standard_User]) ? (
            <div className='flex items-center space-x-2'>
              <span className='text-xs text-red-500'>No Data found!</span>
            </div>
          ) : (
            <div
              onClick={() => viewInitialAssesmentForm(form_uuid)}
              tabIndex={0}
              role='button'
              className='flex items-center space-x-1.5 cursor-pointer'
            >
              <span className='text-xs text-blue-600 hover:text-blue-700 font-medium'>Add information</span>
              <span className='text-blue-600'>
                <FiArrowUpRight className="h-3 w-3" />
              </span>
            </div>
          )}
        </>
      );
    }

    if (
      item?.isBodyModal &&
      parseBooleanVal(item.isBodyModal) &&
      type === "text"
    ) {
      return (
        <CustomButton
          label='View Human Body'
          type='button'
          size="sm"
          clickHandler={() => {
            setSelectedBody(value);
            setOpenBodyModal(true);
          }}
        />
      );
    }

    if (value && typeof value === "object") {
      return Object.keys(value)
          .map((key) => value[key] || "")
          .join(" ");
    }

    if (value && typeof value !== "object") {
      return value;
    }

    return (
      <>
        {roleAccess([USER_ROLE.Sp_Standard_User]) ? (
          <div className='flex items-center space-x-2'>
            <span className='text-xs text-red-500'>No Data found!</span>
          </div>
        ) : (
          <div
            onClick={() => viewInitialAssesmentForm(form_uuid)}
            tabIndex={0}
            role='button'
            className='flex items-center space-x-1.5 cursor-pointer'
          >
            <span className='text-xs text-blue-600 hover:text-blue-700 font-medium'>Add information</span>
            <span className='text-blue-600'>
              <FiArrowUpRight className="h-3 w-3" />
            </span>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div className='bg-gray-50 rounded-lg p-3 border border-gray-100 hover:border-gray-200 transition-colors'>
        <dt className='text-[10px] font-semibold text-gray-500 tracking-wide mb-1.5'>
          {item.lable}
        </dt>
        <dd className='text-xs font-medium text-gray-900 break-words leading-snug'>
          {getValue()}
        </dd>
      </div>
      {openBodyModal && (
        <HumanBodyModal
          title={"View Human Body"}
          view={true}
          selectedValue={selectedBody}
          isOpen={openBodyModal}
          closeModal={() => setOpenBodyModal(false)}
        />
      )}
    </>
  );
};

export default SupportPlanItem;
